var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app ui-kit"},[_c('router-view'),_c('div',{staticClass:"modal-backdrop hide"}),_vm._l((_vm.modals),function(event,index){return _c('Modal',_vm._b({key:index},'Modal',event,false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }